module.exports = __webpack_public_path__ + "static/img/QRcode@2x.a28abcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/QRcode@2x.png
// module id = vEYE
// module chunks = 44